import { useQuery } from '@apollo/client';
import { ApolloProviderV4 } from '~/apollo/client-v4';
import { graphql } from '~/apollo/generated/v4';
import { BookmarkParentType } from '~/apollo/generated/v4/graphql';
import { SpinnerPlaceholder } from '~/components/common/SpinnerPlaceholder';
import { SOItemListV4 } from '~/components/supporting-object/so-item-list-v4';
import { useRouteParam } from '~/hooks/routing';
import { createRefetchQueries } from '~/utils/graphql';

const STUDY_SEDIMENTARY_LOGS_PAGE = graphql(`
  query StudySedimentaryLogsPage($id: ID!) {
    studyGet(id: $id) {
      id
      sedimentaryLogs {
        ...sedimentaryLogParts
        pictures {
          ...soPictureParts
        }
        files {
          ...fileParts
        }
        georeferences {
          ...georeferenceParts
        }
      }
    }
  }
`);

export default function StudySedimentaryLogsPage() {
  return (
    <ApolloProviderV4>
      <StudySedimentaryLogsPageInner />
    </ApolloProviderV4>
  );
}

function StudySedimentaryLogsPageInner() {
  const studyId = useRouteParam('studyId', parseInt);

  const { data, loading } = useQuery(STUDY_SEDIMENTARY_LOGS_PAGE, {
    variables: { id: studyId },
  });

  const refetchQueries = createRefetchQueries([
    { query: STUDY_SEDIMENTARY_LOGS_PAGE, variables: { id: studyId } },
  ]);

  const sedimentaryLogs = data?.studyGet?.sedimentaryLogs ?? [];

  if (loading) return <SpinnerPlaceholder />;

  return (
    <SOItemListV4
      items={sedimentaryLogs}
      soParentType="study"
      soParentId={studyId}
      bookmarkParentType={BookmarkParentType.SedimentaryLog}
      refetchQueries={refetchQueries}
    />
  );
}
